'use client';

import { useState, useEffect } from 'react';
import DocuSignDashboard from '../components/DocuSignDashboard';
import DocuSignDashboardSplit from '../components/DocuSignDashboardSplit';
import { VIEW_PREFERENCE_KEY, VIEW_CLASSIC, VIEW_SPLIT } from '../components/UserAccountMenu';

export default function Home() {
  // Initialize with null to handle hydration properly
  const [currentView, setCurrentView] = useState(null);
  const [isHydrated, setIsHydrated] = useState(false);

  // Read preference from localStorage on mount (client-side only)
  useEffect(() => {
    const savedView = localStorage.getItem(VIEW_PREFERENCE_KEY);
    setCurrentView(savedView === VIEW_CLASSIC ? VIEW_CLASSIC : VIEW_SPLIT);
    setIsHydrated(true);
  }, []);

  // Handle view change from UserAccountMenu
  const handleViewChange = (newView) => {
    setCurrentView(newView);
    // localStorage is already updated in UserAccountMenu
  };

  // Show nothing during hydration to prevent mismatch
  if (!isHydrated) {
    return (
      <main className="min-h-screen bg-white">
        {/* Loading placeholder during hydration */}
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-pulse text-gray-400">Loading...</div>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-white">
      {currentView === VIEW_SPLIT ? (
        <DocuSignDashboardSplit
          currentView={currentView}
          onViewChange={handleViewChange}
        />
      ) : (
        <DocuSignDashboard
          currentView={currentView}
          onViewChange={handleViewChange}
        />
      )}
    </main>
  );
}
